<template>
	<div class="center_order_container">
		<div class="list_title">
			<div class="title">订单</div>
			<div class="tag">&nbsp;</div>
		</div>
		
		<!-- 订单产品列表 -->
		<div class="list" v-if="productData && productData.list && productData.list.length>0">
			<div class="items" v-for="(item, index) in productData.list">
				<div @click="toDetail(tem)" v-for="(tem, dex) in item.list" :key="dex" class="item" :class="{'noborder':dex == item.list.length-1}">
					<img class="cover" v-if="tem.teacher_list && tem.teacher_list.length>0" :src="tem.teacher_list[0].img_url" />
					<div class="mes">
						<div class="title">{{tem.title}}</div>
						<div class="info">
							<div class="price">下单时间：{{item.created_at}}</div>
							<div class="price">实际应付：¥{{tem.price}}</div>
							<div class="price">订单状态：
								<span v-if="item.result == 0">未支付</span>
								<span v-if="item.result == 1">已支付</span>
								<span v-if="item.result == 2">已退款</span>
								<span v-if="item.result == 3">已取消</span>
							</div>
						</div>
					</div>
				</div>
				<div class="btns" v-if="item.result == 0">
					<div class="btn white" @click="cancelOrderClick(item)">取消</div>
					<div class="btn" @click="toOrderDetail(item)">付款</div>
				</div>
			</div>
		</div>
		
		<div class="empty_box" v-if="productData.list && productData.list.length==0">
			<img class="empty_icon" src="../../assets/images/empty.png" />
			<div class="empty_texts" @click="toList()">
				<span class="empty_text">没有找到相关订单</span>
				<span class="empty_link">去看看有哪些课程</span>
			</div>
		</div>
		
		<!-- 购买提示 -->
		<el-dialog title="支付订单" width="420px" top="28vh" :visible.sync="dialogQrVisible" :show-close="true">
			<div
				style=" width: 100%; height: 150px; display: flex; flex-direction: column;justify-content: center;align-items: center;">
				<div ref="qrcode" style="width: 150px; height: 150px;"></div>
				<div style="margin-top: 10px;">
					请扫码二维码支付订单
				</div>
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogQrVisible = false">取消支付</el-button>
				<el-button type="primary" @click="finishedClick">支付完成</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import QRCode from "qrcodejs2";
	import apiUrl from "../../js/apiUrl.js";
	
	export default {
		data() {
			return {
				search: {
					page_index: 1,
					page_size: 100,
					order_by: ''
				},
				productData: {
					total: 0,
					count: 0,
					list: null
				},
				selected:null,
				dialogQrVisible: false
			}
		},
		components: {
			qrcode: QRCode,
		},
		created() {
			document.title = "订单";
			this.productDataGet(1);
		},
		methods: {
			toDetail(item) {
				this.GoToDetail(item.product_type, item.product_id);
			},
			finishedClick(){
				var that = this;
				this.dialogQrVisible = false;
				this.productDataGet(1,()=>{
					var item = that.productData.list.filter(i=> that.selected.order_id == i.order_id && i.result == 1);
					if(item){
						that.$emit('selectedClick', 2);
					}
				});
			},
			toOrderDetail(item){
				var that = this;
				that.selected = item;
				that.dialogQrVisible = true;
				if (!that.qrcode) {
					that.$nextTick(() => {
						var qrcode_url = 'https://m.cmptt.com/pages/center/orderDetails?state=1&id='+item.order_id
						that.setupQrCode(that.$refs.qrcode, qrcode_url, 150, (code_img) => {
							that.qrcode = code_img;
						});
					});
				}
			},
			cancelOrderClick(item){
				var that = this;
				var url = apiUrl.tt_course_order_cancel;
				var parm = {order_id:item.order_id,client_type:10};
				this.Ajax(url, parm, (data) => {
					item.result = 3;
					that.productData.list.forEach((tem,dex)=>{
						if(tem.order_id == item.order_id){
							tem.result = 3;
						}
					});
					that.$message({
					  showClose: true,
					  message: '订单已取消',
					  type: 'warning'
					});
				});
			},
			productDataGet(index,callback) {
				var that = this;
				if (index <= 1) {
					that.search.page_index = 1;
					that.productData.count = 1;
					that.productData.list = [];
				}
				if (that.search.page_index > that.productData.count) {
					return;
				}
				that.search.page_index = index;
				var url = apiUrl.tt_course_order_list_get;
				this.Ajax(url, this.search, (data) => {
					if (that.search.page_index == 1) {
						that.productData.list = [];
						that.productData.total = data.total;
						that.productData.count = data.count;
					}
					if (data && data.list.length > 0) {
						that.productData.list = that.productData.list.concat(data.list);
					}
					if(callback) callback();
				});
			},
			//QrCode
			setupQrCode(el, url, width, callback) {
				let code_img = new QRCode(el, {
					width: width,
					height: width, // 高度
					text: url, // 二维码内容
					colorDark: '#333333',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.L,
				});
				if (callback) callback(code_img);
			},
		},
	}
	
</script>

<style lang="scss" scoped>
	.center_order_container {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #fff;
		
		.empty_box {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		
			.empty_icon {
				width: 220px;
				height: auto;
			}
		
			.empty_texts {
				display: flex;
				flex-direction: column;
				color: #C0C4CC;
				line-height: 1;
				cursor: pointer;
		
				.empty_text {
					font-size: 15px;
					margin-bottom: 10px;
					text-align: center;
				}
		
				.empty_link {
					font-size: 17px;
					border-bottom: 1px solid #C0C4CC;
					padding-bottom: 2px;
					text-align: center;
				}
			}
		}
		
		
		.list {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			box-sizing: border-box;
			margin-top: 20px;
			
			
			.items{
				width: 100%;
				border: 1px solid #eee;
				padding:0 15px;
				margin-bottom: 30px;
				box-sizing: border-box;
				
				.btns{
					display: flex;
					justify-content: flex-end;
					width: 100%;
					padding: 15px 0;
					border-top: 1px solid #eee;
					
					.btn{
						background-color: #C93A2E;
						color: #fff;
						width: 128px;
						height: 40px;
						display: flex;
						justify-content: center;
						align-items: center;
						font-size: 14px;
						box-sizing: border-box;
						cursor: pointer;
						border-radius: 4px;
						
						&.white{
							border: 1px solid #C93A2E !important;
							background-color: #fff !important;
							color: #C93A2E !important;
							margin-right: 20px;
						}
					}
				}
				
		
				.item {
					width: 100%;
					display: flex;
					justify-content: space-between;
					border-bottom: 1px solid #eee;
					padding: 15px 0;
					box-sizing: border-box;
					cursor: pointer;
					
					&.noborder {
						border: 0;
					}
					
						
					.cover {
						width: 121px;
						height: 160px;
						box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.1);
						-o-object-fit: cover;
						object-fit: cover;
						position: relative;
						border-radius: 5px;
					}
						
					.mes {
						flex: 1;
						margin-left: 20px;
						display: flex;
						flex-direction: column;
						position: relative;
						
						.title {
							color: #333333;
							font-size: 16px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
						}
						
						.info {
							width: 100%;
							position: absolute;
							right: 0;
							bottom: 0;
							display: flex;
							flex-direction: column;
							
						
							.price {
								font-size: 14px;
								color: #999;
							}
						}
					}
				}
			}
			
		}
		
	}
</style>